<!-- 微信申请审批 -->
<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" :tab="$t('待办')">
        <Unprocessed :id="id" />
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('已办')" force-render>
        <Completed :id="id" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  // import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Unprocessed from './unprocessed'
  import Completed from './completed'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';

  export default {
    name: 'ConstructionDetailList',
    mixins:[mixinDevice],
    components: {
      Unprocessed,
      Completed
    },
    props:{
      id:{
        type: String,
        default: ''
      }
    },
    data () {
      return {}
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {}
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>